import { Box, Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import EirInformation from '../eir-information/EirInformation';
import styles from './styles';

const EirDepositTooltip = ({ hasMBBOffer }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);

  return (
    <Box maxWidth='md' sx={styles(theme).toolTipContainer}>
      <Collapse in={open}>
        <Alert
          severity='info'
          role='none'
          sx={styles(theme).infoContainer}
          data-focus-bg='rgb(229, 246, 253)'
          action={
            <IconButton
              aria-label='close'
              size='medium'
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon sx={{ color: theme.palette.primary.textColor3 }} />
            </IconButton>
          }
        >
          <Box>
            <EirInformation
              titleVariant='subtitle1'
              title={hasMBBOffer ? 'Device deposit' : 'Handset’s deposit'}
              description='Advanced payment may be required. This payment will be credited to your account against future bills.'
              textAlign='left'
              style={{
                title: {
                  mt: 0,
                  fontSize: { xs: theme.typography.h6.fontSize },
                  color: theme.palette.primary.textColor3,
                },
                description: {
                  fontSize: { xs: theme.typography.body2.fontSize },
                  color: theme.palette.primary.textColor3,
                },
              }}
            />
          </Box>
        </Alert>
      </Collapse>
    </Box>
  );
};

export default EirDepositTooltip;
